module.exports = __webpack_public_path__ + "static/2-8a05c3cda9258110fbbead96fd3ac39a.jpg";